import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {StoreService} from "./store.service";
import {EmpresaEntity} from "../../../shared/entity/empresa.entity";

@Injectable({
  providedIn: 'root',
})

export class AppSesionStore extends StoreService<any> {


  constructor() {
    super(null);
  }

  /**
   * Getters
   */

  get currentEmpresa() {
    return this.state.currentEmpresa;
  }



  public currentEmpresaSesion$: Observable<EmpresaEntity> = this.select((state) => {
    return state?.currentEmpresa;
  });


  public setCurrentEmpresaSesion(empresa:EmpresaEntity) {
    this.setState({currentEmpresa: empresa});
  }

  /**
   * Set | Get Can skip version
   */



}
